import Image from 'next/image'
import type { RotationAlbum } from '@/lib/rotation/types'

export function ShelfFallback({ albums }: { albums: RotationAlbum[] }) {
  const rows = [
    { id: 'upper', albums: albums.slice(0, 4) },
    { id: 'lower', albums: albums.slice(4) },
  ]
  return (
    <div className="rotation-fallback" aria-label="Albums on the shelf">
      {rows.map((row) => (
        <div key={row.id}>
          {row.albums.map((album) => (
            <Image
              unoptimized
              key={album.id}
              src={album.coverUrl}
              alt={`${album.title} by ${album.artist}`}
              width={512}
              height={512}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
